<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách sim"
          v-model="table.searchText"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách sim</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.stt }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.iccId }}</td>
            <td>{{ props.item.activatedDate }}</td>
            <td>{{ props.item.dataTime }}</td>
            <td>{{ props.item.data }}</td>
            <td class="red--text">{{ props.item.errCode }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'STT',
            value: 'stt'
          },
          {
            text: 'SĐT',
            value: 'phone'
          },
          {
            text: 'ICCID',
            value: 'iccId'
          },
          {
            text: 'Ngày kích hoạt',
            value: 'activatedDate'
          },
          {
            text: 'Ngày cập nhật',
            value: 'dataTime'
          },
          {
            text: 'Dung lượng (KB)',
            value: 'data'
          },
          {
            text: 'Lỗi (nếu có)',
            value: 'errCode'
          }
        ]
      }
    };
  },
  methods: {
    exportToExcel () {
      if (this.datasource.length > 0) {
        let dataToExport = [];
        this.datasource.map((item, index) => {
          let data = {
            STT: item.stt,
            SĐT: item.phone,
            ICCID: item.iccId,
            'Ngày kích hoạt': item.activatedDate,
            'Dung lượng (KB)': item.data,
            'Ngày cập nhật': item.dataTime,
          };
          dataToExport.push(data);
          return 0;
        });

        let sheet = XLSX.utils.json_to_sheet(dataToExport);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, 'SimData');
        XLSX.writeFile(wb, 'Sims-data.xlsx');
      } else {
        window.getApp.showMessage('Không có dữ liệu', 'error');
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/sim/components/DataList.vue